import * as countryService from '/source/js/services/countryService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';

const RADIO_CHECKED = 'language-radio__label-checked';
const DD_SELECTED = 'select-box__selected';
const DD_FOCUSED = 'select-dropdown__is-focused ';
const CURR_REGION = $("input[name='Region']:checked").val();
const CURR_LANG = $("input[name='langSelection']:checked").val();
let catalogSelectorData;
var isRecommendedCartFlow = document.querySelector('.recommended-cart');

function selectedRadio() {
    let $radioLabel = $('.language-radio__label');
    let $radioInput = $('input.language-radio__input');

    $radioLabel.click(function (e) {
        e.stopPropagation();
        let $this = $(this);
        if($radioInput.is(':checked')) {
            $radioLabel.removeClass(RADIO_CHECKED);
            $this.addClass(RADIO_CHECKED);
        }
    });

    // Keyboard activation for language radio labels
    $radioLabel.on('keydown', function(e) {
        if(e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).find('input[type="radio"]').prop('checked', true).trigger('change');
            $(this).click();
        }
    });
}

export function showAlerts() {
    $('.alert--order').show();
    $('.alert--country').show();
}

export function clearAlerts() {
    $('.alert--order').hide();
    $('.alert--country').hide();
    $('.alert--orderType').hide();
}

function countryDropDown() {
    let $selectButton = $('.select-box__current');
    let $ddContainer = $('.select-dropdown');
    let $ddList = $('.select-box__list');
    let $ddSelection = $('.select-box__option');

    if(isRecommendedCartFlow !== null) {
        $('.select-box__current').addClass('hide-dropdown');
    }

    function openDropdown() {
        $ddList.show();
        $ddContainer.addClass(DD_FOCUSED);
        $ddContainer.attr('aria-expanded', 'true');
    }

    function closeDropdown() {
        $ddList.hide();
        $ddContainer.removeClass(DD_FOCUSED);
        $ddContainer.attr('aria-expanded', 'false');
    }

    $selectButton.click(function () {
        if($ddList.is(':hidden')) {
            if(isRecommendedCartFlow == null) {
                openDropdown();
                return false;
            }
        } else {
            closeDropdown();
        }
    });

    $(document).click(function() {
        closeDropdown();
    });

    $ddList.click(function(e) {
        $ddContainer.addClass(DD_FOCUSED);
        e.stopPropagation();
    });

    // Keyboard support for the dropdown
    $selectButton.on('keydown', function (e) {
        let key = e.which || e.keyCode;
        if(key === 13 || key === 32) {
            e.preventDefault();
            if($ddList.is(':hidden')) {
                if(isRecommendedCartFlow == null) {
                    openDropdown();
                    $ddSelection.filter('.' + DD_SELECTED).focus();
                }
            } else {
                closeDropdown();
            }
        }
        if(key === 27) {
            closeDropdown();
            $selectButton.focus();
        }
        if(key === 40) {
            e.preventDefault();
            if($ddList.is(':hidden') && isRecommendedCartFlow == null) {
                openDropdown();
            }
            let $visible = $ddSelection.filter(':visible');
            let $focused = $visible.filter('.' + DD_SELECTED);
            let idx = $visible.index($focused);
            if(idx < $visible.length - 1) {
                $visible.eq(idx + 1).focus();
            }
        }
        if(key === 38) {
            e.preventDefault();
            let $visible = $ddSelection.filter(':visible');
            let $focused = $visible.filter('.' + DD_SELECTED);
            let idx = $visible.index($focused);
            if(idx > 0) {
                $visible.eq(idx - 1).focus();
            }
        }
    });

    $ddSelection.attr('tabindex', '-1');
    $ddSelection.on('keydown', function (e) {
        let key = e.which || e.keyCode;
        let $visible = $ddSelection.filter(':visible');
        let idx = $visible.index($(this));
        if(key === 40) {
            e.preventDefault();
            if(idx < $visible.length - 1) {
                $visible.eq(idx + 1).focus();
            }
        }
        if(key === 38) {
            e.preventDefault();
            if(idx > 0) {
                $visible.eq(idx - 1).focus();
            }
        }
        if(key === 13 || key === 32) {
            e.preventDefault();
            $(this).click();
            closeDropdown();
            $selectButton.focus();
        }
        if(key === 27) {
            closeDropdown();
            $selectButton.focus();
        }
    });

    $ddSelection.click(function() {
        let $this = $(this);
        $ddSelection.removeClass(DD_SELECTED);
        $this.addClass(DD_SELECTED);
        // Update aria-selected on listbox items
        $ddList.find('[role="option"]').attr('aria-selected', 'false');
        $this.closest('[role="option"]').attr('aria-selected', 'true');
        $('.alert--country').show();
        handleLanguageSelection($(this).attr('value'));
    });
}

function handleLanguageSelection(currentCountryRadioValue) {
    $('[id ^= LangRadioLabel]').hide();

    if(currentCountryRadioValue !== CURR_REGION) {
        var currCartItems = document.getElementById('hidden-cartItem-count');
        if(currCartItems && currCartItems.value > 0) {
            showAlerts();
        } else {
            clearAlerts();
        }
    } else {
        clearAlerts();
    }

    var allLangRadioElements = document.querySelectorAll('[id^=LangRadioLabel]');
    var currentCountryLanguages = document.getElementById('hdnFlag' + currentCountryRadioValue);
    if(!currentCountryLanguages) return;

    var languagesString = currentCountryLanguages.value;
    let defaultLanguageSelected = false;

    for (var i = 0; i < allLangRadioElements.length; i++) {
        if(languagesString.includes(allLangRadioElements[i].firstElementChild.value)) {
            let $langRadioLabel = $('#LangRadioLabel' + allLangRadioElements[i].firstElementChild.value);

            $langRadioLabel.show();
            if(languagesString.trim().split(' ').length === 1 || allLangRadioElements[i].firstElementChild.value === CURR_LANG) {
                $langRadioLabel.trigger('click');
                defaultLanguageSelected = true;
            } else if(!defaultLanguageSelected) {
                $langRadioLabel.trigger('click');
                defaultLanguageSelected = true;
            }
        }
    }

    // Only include language labels in Tab order when there are multiple choices
    var $visibleLabels = $('.language-radio__label:visible');
    if($visibleLabels.length <= 1) {
        $visibleLabels.attr('tabindex', '-1');
    } else {
        $visibleLabels.attr('tabindex', '0');
    }
}

function initEventHandlers() {
    let $catalogSelector = $('.catalogSelectorModal');
    catalogSelectorData = $catalogSelector.data('catalog-selector');
    if(catalogSelectorData) { return; }
    countryDropDown();
    if(window.location.href.toLowerCase().includes('brand-partner-benefits')) {
        $('[data-hide-for-bp="True"]').hide();
    }
    selectedRadio();
    clearAlerts();
    $('.close').on('click', clearAlerts);
    var currentCountry = $("input[name='Region']:checked").val();
    handleLanguageSelection(currentCountry);
    $('#SubmitCountryButton').click(async function () {
        loadSpinner();
        window.sessionStorage.setItem('cultureChanged', 'true');
        var region = $("input[name='Region']:checked").val();
        let langSelection = '';
        langSelection = $("input[name='langSelection']:checked").val();
        if(region === CURR_REGION && langSelection === CURR_LANG) {
            stopSpinner();
            $('#countryChooser').modal('hide');
            return;
        }
        const result = await countryService.changeContextForCountry(region, langSelection);
        if(result) {
            $('#countryChooser').modal('hide');
            $('#countryChooser').on('hide.bs.modal', stopSpinner);
            window.location = result;
        }
    });
}

$(function () {
    initEventHandlers();
});
